"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _lodash = _interopRequireDefault(require("lodash.get")),
    _creditsContext = _interopRequireDefault(require("../contexts/creditsContext")),
    _creditsContextSelector = _interopRequireDefault(require("../selectors/creditsContextSelector"));

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var CreditsProvider = function (_Component) {
  function CreditsProvider() {
    var _this;

    return (0, _classCallCheck2["default"])(this, CreditsProvider), _this = _super.call(this), _this.loadCreditsInformation = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
      var _this$props, getOrganisation, getUserTeams, _yield$Promise$all, _yield$Promise$all2, orgResponse, teamsResponse, invalidOrgData, selectedOrganisation, userTeams, creditBalance, _selectedOrganisation, videoQuantity, creditType;

      return _regenerator["default"].wrap(function (_context) {
        for (;;) {
          switch (_context.prev = _context.next) {
            case 0:
              return _this$props = _this.props, getOrganisation = _this$props.getOrganisation, getUserTeams = _this$props.getUserTeams, _context.next = 3, Promise.all([getOrganisation(), getUserTeams()]);

            case 3:
              if (_yield$Promise$all = _context.sent, _yield$Promise$all2 = (0, _slicedToArray2["default"])(_yield$Promise$all, 2), orgResponse = _yield$Promise$all2[0], teamsResponse = _yield$Promise$all2[1], invalidOrgData = !orgResponse.data || !orgResponse.data.getOrganisation || orgResponse.error, !invalidOrgData) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              selectedOrganisation = orgResponse.data.getOrganisation, userTeams = (0, _lodash["default"])(teamsResponse, "data.getUserTeams", []), creditBalance = selectedOrganisation.creditBalance, _selectedOrganisation = selectedOrganisation["package"], videoQuantity = _selectedOrganisation.videoQuantity, creditType = _selectedOrganisation.creditType, _this.setState({
                userTeams: userTeams,
                isUnlimited: -1 === videoQuantity,
                creditType: creditType,
                creditBalance: creditBalance
              });

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this.state = {
      userTeams: [],
      creditBalance: {
        balance: 0,
        creditTotal: 0,
        rolloverBalance: 0,
        rolloverTotal: 0
      }
    }, _this;
  }

  (0, _inherits2["default"])(CreditsProvider, _Component);

  var _super = _createSuper(CreditsProvider);

  return (0, _createClass2["default"])(CreditsProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.loadCreditsInformation();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children,
          _this$state = this.state,
          userTeams = _this$state.userTeams,
          isUnlimited = _this$state.isUnlimited,
          creditType = _this$state.creditType,
          creditBalance = _this$state.creditBalance;
      return _react["default"].createElement(_creditsContext["default"].Provider, {
        value: (0, _creditsContextSelector["default"])({
          state: {
            userTeams: userTeams,
            isUnlimited: isUnlimited,
            creditType: creditType,
            creditBalance: creditBalance
          },
          actions: {
            onCreditsUpdated: this.loadCreditsInformation
          }
        })
      }, children);
    }
  }]), CreditsProvider;
}(_react.Component),
    _default = CreditsProvider;

exports["default"] = _default;